import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { type IAgentHandoffNotifySettings } from 'entities/Chatbot'
import { HandoffNotifySettingsStore } from 'entities/AIAgent/ui/HandoffNotifySettings/store/HandoffNotifySettingsStore.ts'
import { type ChatbotStore } from 'pages/chatbot'
import { ChatbotAction } from 'pages/chatbot/store/chatbotActionStore.ts'

export class StepHandoffStore {
  readonly handoffNotifySettingsStore
  constructor(private _chatbotStore: ChatbotStore, private _entities: IEntitiesStore) {
    this.handoffNotifySettingsStore = new HandoffNotifySettingsStore(
      this._entities,
      undefined,
      this
    )
    this.actions = new ChatbotAction(
      this._chatbotStore.model.handoffActions,
      this._chatbotStore.errors.handoffActions,
      this._entities
    )
    makeAutoObservable(this)
  }

  get settings() {
    return this._chatbotStore.model.settings
  }

  get enabled() {
    return !!this.settings.handoff_enabled?.value
  }
  setEnabled = (value: boolean) => {
    this.clearError()
    this.settings.set_handoff_enabled({
      value,
    })
  }

  get notifySettings(): IAgentHandoffNotifySettings {
    return this.settings.handoff_notify_settings?.value || {}
  }

  setNotifySettings = (value: typeof this.notifySettings) => {
    this.clearError()
    this.settings.set_handoff_notify_settings({
      value: {
        ...this.notifySettings,
        ...value,
      },
    })
  }

  readonly actions: ChatbotAction

  private _error = ''
  get error() {
    return this._error
  }
  setError = (value: string) => {
    this._error = value
  }

  clearError = () => {
    this._error = ''
  }

  validate = () => {
    let isError = false
    if (!this.enabled) return false
    const handoffNotifySettingsStoreError = this.handoffNotifySettingsStore.validate()
    if (handoffNotifySettingsStoreError) {
      this.setError(handoffNotifySettingsStoreError)
      isError = true
    }
    return isError
  }
}
